import { Button, GenericDialog, H2, SelectIconItem } from '@/common'
import { useTranslation } from 'react-i18next'
import { AssetDefinition } from '@/shared/hooks/api/appConfig'
import { useState } from 'react'

export function SingleAssetIconSelectDialog({
  isOpen,
  close,
  assetDefinitions,
  onAdd,
  title
}: {
  isOpen: boolean
  close: () => void
  assetDefinitions: (AssetDefinition & {
    icon?: React.ReactNode
  })[]
  onAdd: (payload: {
    assetDefinitionId: string | null
    customName: string | null
    isCustom: boolean
  }) => void
  title?: string
}) {
  const notListedValue = 'NOT_LISTED'
  const [selectedAssetDefinitionId, setSelectedAssetDefinitionId] = useState<string | null>(null)
  const [isAddingCustomAsset, setIsAddingCustomAsset] = useState(false)
  const [customName, setCustomName] = useState<string | null>(null)
  const { t } = useTranslation()
  const isAddDisabled = !selectedAssetDefinitionId && !customName

  const onChange = (assetDefinitionId: string | null) => {
    if (assetDefinitionId === notListedValue) {
      setSelectedAssetDefinitionId(null)
      setIsAddingCustomAsset(true)
      setCustomName(null)
    } else {
      setSelectedAssetDefinitionId(assetDefinitionId)
      setIsAddingCustomAsset(false)
    }
  }

  const onAddClick = () => {
    if (!selectedAssetDefinitionId && !customName) {
      return
    }
    onAdd({
      assetDefinitionId: selectedAssetDefinitionId,
      customName,
      isCustom: isAddingCustomAsset
    })
  }

  return (
    <GenericDialog isOpen={isOpen} close={close}>
      <div className="rounded-lg border w-screen max-w-4xl bg-white px-6 py-10">
        <div className="space-y-8">
          <div className="text-center mb-4">
            <H2>{title}</H2>
          </div>
          <div className="grid grid-cols-2 gap-2">
            {assetDefinitions.map(assetDefinition => {
              return (
                <SelectIconItem<string>
                  key={assetDefinition.id}
                  id={assetDefinition.id}
                  name="electrolyticCellSystemDialog"
                  title={t(`assets:${assetDefinition.id}`)}
                  value={assetDefinition.id}
                  isChecked={selectedAssetDefinitionId === assetDefinition.id}
                  icon={assetDefinition.icon}
                  onChange={onChange}
                />
              )
            })}
          </div>
          <div className="gap-2 flex justify-end">
            <Button variant="neutral" onClick={close}>
              {t('common:actions.cancel')}
            </Button>
            <Button onClick={onAddClick} disabled={isAddDisabled}>
              {t('common:actions.add')}
            </Button>
          </div>
        </div>
      </div>
    </GenericDialog>
  )
}
